import script from "./AgentSideNavbar.vue?vue&type=script&setup=true&lang=js"
export * from "./AgentSideNavbar.vue?vue&type=script&setup=true&lang=js"

import "./AgentSideNavbar.vue?vue&type=style&index=0&id=5d26727a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d26727a"]])

export default __exports__